export default class Chamada {
  constructor(titulo = '', inscricaoInicio = '', inscricaoFim = '', utilizaCadunico = true,) {
    this.titulo = titulo;
    this.inscricaoInicio =	inscricaoInicio;
    this.inscricaoFim = inscricaoFim;
    this.utilizaCadunico = utilizaCadunico;
  }
}
